


import { Component, Vue } from "vue-property-decorator";

import { CustomNotification } from "@Internal/Models";

import { Roles } from "App";
import { Role } from "App/Models";
import { $t, EventBus } from "App/IOC";

import PrivilegeGrid from "../PrivilegeGrid.vue";

const PRIVILEGE_KEYS: ( keyof Role )[] = [
    "PlanRead", "PlanUpdate", "CouponRead", "CouponCreate",
    "CustomerRead", "CustomerCreate", "AdsPublicationRead", "AdsPublicationCreate"
];

function NewModel() {
    return {
        Name: "",
        Description: "",
        PlanRead: false,
        PlanUpdate: false,
        CouponRead: false,
        CouponCreate: false,
        CustomerRead: false,
        CustomerCreate: false,
        AdsPublicationRead: false,
        AdsPublicationCreate: false
    };
}

@Component({
    components: {
        PrivilegeGrid
    }
})
export default class SingleRoleView extends Vue {
    private original?: Role;
    private model = NewModel();

    private loading: boolean = true;
    private dirty: boolean = false;

    private get isProtected(): boolean {
        return this.original !== undefined && this.original.IsProtected === true;
    }

    private get editable(): boolean {
        return !this.isProtected;
    }

    private async created() {
        await this.load();
    }

    private async load(): Promise<void> {
        const [ role, error ] = await Roles.Get( Number( this.$route.params.id ) );

        if( error !== undefined || role === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.original = role;
        this.seed( role );

        this.loading = false;
        this.dirty = false;

        if( role.Name !== undefined )
            document.title = role.Name;
    }

    private seed( role: Role ): void {
        const model: any = NewModel();

        model.Name = role.Name !== undefined ? role.Name : "";
        model.Description = role.Description !== undefined ? role.Description : "";

        for( const key of PRIVILEGE_KEYS )
            model[ key ] = ( role as any )[ key ] === true;

        this.model = model;
    }

    private markDirty(): void {
        this.dirty = true;
    }

    private async save(): Promise<void> {
        if( this.original === undefined || !this.editable )
            return;

        const updated: any = { ...this.original };

        updated.Name = this.model.Name;
        updated.Description = this.model.Description;

        for( const key of PRIVILEGE_KEYS )
            updated[ key ] = ( this.model as any )[ key ];

        const [ result, error ] = await Roles.Update( this.original, updated );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        EventBus.Publish( "Notification", CustomNotification.Success(
            $t( "ROLES_updateTitle" ), $t( "ROLES_updated" )
        ));

        if( result !== undefined )
            this.original = result;

        this.dirty = false;
        this.load();
    }
}
